<template>
  <!--商品列表页面-->
  <div>
    <van-col :span="24" v-if="list.length>0">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :head-height="100">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('onLoad.finished_text')"
          @load="onLoadShopProductList"
        >
          <vuedraggable v-model="list" draggable=".item" @update="datadragEnd" :delay="80"  :options="{animation:800}" :disabled="this.disabled">
                <div v-for="(item, k) in list" :key="k" class="item">
                  <div class="shop_roduct_list_bor">
                    <van-row>
                      <van-col span="6">
                        <van-image  class="shop_roduct_list_img" :src="item.shop_logo" />
                      </van-col>
                      <van-col span="18">
                        <van-col span="24" class="shop_roduct_list_title"> {{ item.shop_name }}</van-col>
                        <van-col span="24" class="shop_roduct_list_price">
                          <span v-show="item.shop_price_custom != 2">{{ item.shop_price }} 円</span>
                        </van-col>
                        <van-col span="24" class="shop_roduct_list_bottom">
                          <van-row gutter="10">
                            <van-col span="6" class="shop_roduct_list_edit" @click="addShop(item.id)"><img src="../assets/img/edit.png"  class="shop_icon"/><span>{{ $t('shop.edit') }}</span></van-col>
                            <van-col span="10" class="shop_roduct_list_edit" @click="topShop(item.id, 1)" v-if="item.is_top == 0"><img src="../assets/img/top.png" class="shop_icon_two"/><span>{{ $t('shop.top') }}</span></van-col>
                            <van-col span="10" class="shop_roduct_list_edit" @click="topShop( item.id,0)" v-else><img src="../assets/img/top.png" class="shop_icon_two"/><span>{{ $t('shop.del_top') }}</span></van-col>
                            <van-col span="6" class="shop_roduct_list_edit" @click="deleteShop(item.id)"><img src="../assets/img/del.png"  class="shop_icon"/><span>{{ $t('shop.delete') }}</span></van-col>
                          </van-row>
                        </van-col>
                      </van-col>
                    </van-row>
                  </div>
                </div>
          </vuedraggable>
       </van-list>
      </van-pull-refresh>
    </van-col>
    <van-col v-else>
      <van-list style="margin-top: 10em;margin-left: 2em;"
        v-model="loading"
        :finished="finished"
        :finished-text="$t('onLoad.add_shop')"
        @load="onLoadShopProductList"
      >
      </van-list>
    </van-col>
    <van-overlay :show="overlayShow" @click="overlayShow = false" >
      <van-loading size="24px" text-color="#0094ff" color="#1989fa" style="padding-top: 80%;" vertical>加载中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
    import axios from "axios";
    import { Toast, Dialog, PullRefresh } from 'vant'
    import vuedraggable from 'vuedraggable'
    export default {
      name: "shop_product_list",
      components:{
        vuedraggable,
        [PullRefresh.name]: PullRefresh
    },
        data() {
            return {
              overlayShow: false,
              disabled: false,
              list: [],
              loading: false,
              finished: false,
              longClick:false,
              page: 0,
              isLoading: false,
            }
        },
        created: function () {
            document.title = this.$t('shop.Product_list');
        },
        methods: {
          onRefresh () {
            // 下拉刷新
            this.finished = false
            this.isLoading = false
            this.list = []
            this.page = 0
            this.onLoadShopProductList()
          },
          datadragEnd(e) {
            // 最大key值
            const oldIndex = e.oldIndex
            // 最小key值
            const newIndex = e.newIndex
            let i = newIndex > oldIndex ? oldIndex : newIndex
            const d = newIndex > oldIndex ? newIndex : oldIndex
            let indexAaary = []
            for(i; i <= d; i++) {
              let indexValue = {}
              if(newIndex > oldIndex){
                // 向下排序
                if( i === newIndex){
                  indexValue.id = this.list[newIndex].id
                  indexValue.order = this.list[newIndex - 1].order - 1
                }else{
                  indexValue.id =  this.list[i].id
                  indexValue.order =  this.list[i].order + 1
                }
              }else{
                // 向上排序
                indexValue.id = this.list[i].id
                indexValue.order = i === newIndex ? this.list[newIndex + 1].order  : this.list[i].order - 1
              }
              this.list[i].id = indexValue.id
              this.list[i].order = indexValue.order
              indexAaary.push(indexValue)
            }
            this.updateOrder(indexAaary);
          },
          updateOrder(indexAaary) {
            const uid = this.$route.query.uid;
            const token = this.$route.query.token;
            axios.get(this.baseUrlApi + "/mapi/public/index.php/api/shop_api/goods_order", {
              params: {
                uid: uid,
                token: token,
                order: JSON.stringify(indexAaary)
              }
            }).then(res => {});
          },
          addShop(id) {
            //添加商品
            this.overlayShow = true
            const uid = this.$route.query.uid;
            const token = this.$route.query.token;
            this.$router.push({path:'/ShopAdd', query: {uid: uid, token: token,id:id}});
          },
          deleteShop: function (id) {
                const token = this.$route.query.token;
                const uid = this.$route.query.uid;
              Dialog.confirm({
                title: this.$t('shop.delete'),
                message: this.$t('shop.Delete_item'),
                confirmButtonText: this.$t('btn.submit'),
                cancelButtonText: this.$t('btn.cancel'),
              })
                .then(() => {
                  axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/del_shop_product",
                    {
                      params: {
                        token: token,
                        uid: uid,
                        id: id,
                      }
                    }).then(res => {
                    console.log(res.data);
                    Toast(res.data.msg);
                    if (res.data.code === 1) {
                      setTimeout(() =>{
                        window.location.reload();
                      },3000)
                    }
                  });
                });
            },
            //置顶跟取消 0取消；1置顶
          topShop: function (id,type) {
              const token = this.$route.query.token;
              const uid = this.$route.query.uid;
              Dialog.confirm({
                title: type === 1?this.$t('shop.top'):this.$t('shop.del_top'),
                message: type === 1?this.$t('shop.top'):this.$t('shop.del_top'),
                confirmButtonText: this.$t('btn.submit'),
                cancelButtonText: this.$t('btn.cancel'),
              })
                .then(() => {
                  axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/is_goods_top",
                    {
                      params: {
                        token: token,
                        uid: uid,
                        id: id,
                        type: type,
                      }
                    }).then(res => {
                    console.log(res.data);
                    Toast(res.data.msg);
                    if (res.data.code === 1) {
                      setTimeout(() =>{
                        window.location.reload();
                      },2000)
                    }
                  });
                });
            },

          onLoadShopProductList: function () {
                this.page++;
                const uid = this.$route.query.uid;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/get_shop_product_list", {
                    params: {
                        uid: uid,
                        token: token,
                        page: this.page
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.code === 0) {
                        Toast(res.data.msg);
                        this.finished = true;
                        return;
                    }
                    this.list = res.data.list;
                    // if (this.page === 1) {
                    //     this.list = res.data.list;
                    // } else {
                    //     this.list = this.list.concat(res.data.list)
                    // }

                    // 加载状态结束
                    this.loading = false;
                    //数据全部加载完成
                    if (res.data.list.length < 50) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                    this.isLoading = false;


                });
            }
        }
    }
</script>

<style scoped>


</style>




// WEBPACK FOOTER //
// src/components/shop_product_list.vue